
export class IProcess {
businessUnitCode: string;
code: string;
domain: string;
visionCode: string;
}

